export const translations = {
  nav: {
    services: { en: 'Services', gr: 'Υπηρεσίες' },
    packages: { en: 'Packages', gr: 'Πακέτα' },
    testimonials: { en: 'Testimonials', gr: 'Μαρτυρίες' },
    contact: { en: 'Contact', gr: 'Επικοινωνία' },
  },
  hero: {
    title: { 
      en: 'Elevate Your Gaming Operations', 
      gr: 'Αναβαθμίστε τις Λειτουργίες Σας' 
    },
    subtitle: { 
      en: 'Expert consulting and affiliate solutions for the betting industry. Powered by experience. Driven by results.', 
      gr: 'Εξειδικευμένες συμβουλευτικές και affiliate λύσεις για τον κλάδο στοιχημάτων. Με την εμπειρία. Με αποτελέσματα.' 
    },
    cta: { en: 'Get Started', gr: 'Ξεκινήστε' },
    ctaSecondary: { en: 'Learn More', gr: 'Μάθετε Περισσότερα' },
  },
  services: {
    sectionTitle: { en: 'Our Services', gr: 'Οι Υπηρεσίες Μας' },
    sectionSubtitle: { 
      en: 'End-to-end operational excellence for iGaming operators worldwide', 
      gr: 'Ολοκληρωμένη λειτουργική αριστεία για iGaming operators παγκοσμίως' 
    },
    consulting: {
      title: { en: 'iGaming Operations', gr: 'iGaming Operations' },
      description: { 
        en: 'We take over your operations with absolute success through experienced executives with years of expertise in the gaming industry.', 
        gr: 'Αναλαμβάνουμε τα operations σας με απόλυτη επιτυχία μέσα από έμπειρα στελέχη με πολυετή εμπειρία στον χώρο.' 
      },
      features: {
        en: ['Casino Operations', 'Sportsbook Operations', 'CRM Operations', 'Risk & Fraud', 'Customer Support & KYC', 'Trading & Odds Management'],
        gr: ['Casino Operations', 'Sportsbook Operations', 'CRM Operations', 'Risk & Fraud', 'Customer Support & KYC', 'Trading & Odds Management']
      }
    },
    betguard: {
      title: { en: 'BetGuard App', gr: 'BetGuard App' },
      description: { 
        en: 'Your trusted companion in the betting world. Join our community and discover the best offers, verified operators, and exclusive bonuses - all in one place.', 
        gr: 'Ο έμπιστος σύντροφός σας στον κόσμο του στοιχήματος. Γίνετε μέλος της κοινότητάς μας και ανακαλύψτε τις καλύτερες προσφορές, αξιόπιστους operators και αποκλειστικά μπόνους - όλα σε ένα μέρος.' 
      },
      features: {
        en: ['Daily Best Offers', 'Safety Index Ratings', 'Exclusive Deposit Bonuses', 'Verified Operators'],
        gr: ['Καλύτερη Προσφορά Ημέρας', 'Safety Index Βαθμολογίες', 'Αποκλειστικά Μπόνους Κατάθεσης', 'Πιστοποιημένοι Operators']
      },
      highlights: {
        community: {
          title: { en: 'Growing Community', gr: 'Αναπτυσσόμενη Κοινότητα' },
          description: { en: 'Join thousands of players who trust BetGuard for their daily betting decisions', gr: 'Γίνετε μέλος χιλιάδων παικτών που εμπιστεύονται το BetGuard για τις καθημερινές τους αποφάσεις' }
        },
        safety: {
          title: { en: 'Safety Index', gr: 'Safety Index' },
          description: { en: 'Trust scores based on real player complaints and how operators handle them', gr: 'Βαθμολογίες εμπιστοσύνης βασισμένες σε πραγματικά παράπονα παικτών και τη διαχείρισή τους' }
        },
        offers: {
          title: { en: 'Exclusive Offers', gr: 'Αποκλειστικές Προσφορές' },
          description: { en: 'Special deposit bonuses and rewards available only through BetGuard', gr: 'Ειδικά μπόνους κατάθεσης και δώρα διαθέσιμα μόνο μέσω BetGuard' }
        }
      }
    }
  },
  packages: {
    sectionTitle: { en: 'Our Packages', gr: 'Τα Πακέτα Μας' },
    sectionSubtitle: { 
      en: 'Scalable solutions from advisory to full operations management', 
      gr: 'Επεκτάσιμες λύσεις από συμβουλευτική έως πλήρη διαχείριση operations' 
    },
    starter: {
      title: { en: 'Advisory', gr: 'Advisory' },
      description: { en: 'Expert consulting for existing operations', gr: 'Εξειδικευμένη συμβουλευτική για υπάρχοντα operations' },
      features: {
        en: ['Full Operations Audit', 'Performance Analysis', 'Gap Identification', 'Improvement Recommendations', 'Strategic Roadmap', 'Monthly Review Sessions'],
        gr: ['Πλήρης Έλεγχος Operations', 'Ανάλυση Απόδοσης', 'Εντοπισμός Αδυναμιών', 'Προτάσεις Βελτίωσης', 'Στρατηγικός Οδικός Χάρτης', 'Μηνιαίες Συνεδρίες Review']
      }
    },
    professional: {
      title: { en: 'Setup', gr: 'Setup' },
      description: { en: 'We build your operations from the ground up', gr: 'Δημιουργούμε τα operations σας από το μηδέν' },
      features: {
        en: ['Complete Process Design', 'Operations Infrastructure Setup', 'Team Training & Onboarding', 'KPIs & Reporting Framework', 'Risk Management Protocols', 'Compliance Procedures'],
        gr: ['Σχεδιασμός Διαδικασιών', 'Δημιουργία Υποδομών Operations', 'Εκπαίδευση & Onboarding Ομάδας', 'KPIs & Reporting Framework', 'Πρωτόκολλα Risk Management', 'Διαδικασίες Compliance']
      }
    },
    enterprise: {
      title: { en: 'Full Management', gr: 'Full Management' },
      description: { en: 'We run your operations end-to-end', gr: 'Αναλαμβάνουμε πλήρως τα operations σας' },
      features: {
        en: ['Everything in Setup +', 'Daily Operations Management', 'Dedicated Operations Team', '24/7 Monitoring & Support', 'Continuous Optimization', 'Full P&L Responsibility'],
        gr: ['Όλα τα Setup +', 'Καθημερινή Διαχείριση Operations', 'Αποκλειστική Ομάδα Operations', '24/7 Monitoring & Support', 'Συνεχής Βελτιστοποίηση', 'Πλήρης Ευθύνη P&L']
      }
    },
    cta: { en: 'Discuss Package', gr: 'Συζητήστε το Πακέτο' }
  },
  testimonials: {
    sectionTitle: { en: 'What Our Clients Say', gr: 'Τι Λένε οι Πελάτες Μας' },
    sectionSubtitle: { 
      en: 'Trusted by leading betting operators worldwide', 
      gr: 'Εμπιστεύονται οι κορυφαίοι operators παγκοσμίως' 
    }
  },
  contact: {
    sectionTitle: { en: 'Get In Touch', gr: 'Επικοινωνήστε Μαζί Μας' },
    sectionSubtitle: { 
      en: 'Ready to transform your operations? Let\'s talk.', 
      gr: 'Έτοιμοι να μεταμορφώσετε τις λειτουργίες σας; Ας μιλήσουμε.' 
    },
    form: {
      name: { en: 'Full Name', gr: 'Ονοματεπώνυμο' },
      email: { en: 'Email Address', gr: 'Διεύθυνση Email' },
      company: { en: 'Company Name', gr: 'Όνομα Εταιρείας' },
      package: { en: 'Package Interest', gr: 'Ενδιαφέρον Πακέτου' },
      message: { en: 'Your Message', gr: 'Το Μήνυμά Σας' },
      submit: { en: 'Send Message', gr: 'Αποστολή Μηνύματος' },
      selectPackage: { en: 'Select a package', gr: 'Επιλέξτε πακέτο' },
      success: { en: 'Message sent successfully! We\'ll get back to you soon.', gr: 'Το μήνυμα στάλθηκε επιτυχώς! Θα επικοινωνήσουμε σύντομα.' },
      error: { en: 'Failed to send message. Please try again.', gr: 'Αποτυχία αποστολής. Παρακαλώ δοκιμάστε ξανά.' }
    }
  },
  footer: {
    tagline: { 
      en: 'Transforming gaming operations with expertise and innovation.', 
      gr: 'Μεταμορφώνουμε τις gaming λειτουργίες με εμπειρία και καινοτομία.' 
    },
    quickLinks: { en: 'Quick Links', gr: 'Γρήγοροι Σύνδεσμοι' },
    contactUs: { en: 'Contact Us', gr: 'Επικοινωνία' },
    rights: { en: 'All rights reserved.', gr: 'Με επιφύλαξη παντός δικαιώματος.' }
  }
};

export const testimonials = [
  {
    id: 1,
    name: { en: 'Marcin Hospod', gr: 'Marcin Hospod' },
    role: { en: 'Head of CRM, Casino Nova', gr: 'Head of CRM, Casino Nova' },
    image: 'https://images.unsplash.com/photo-1745060594679-61578eb592f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMG1hbiUyMHBvcnRyYWl0JTIwZGFya3xlbnwwfHx8fDE3NzU0NzUxMzN8MA&ixlib=rb-4.1.0&q=85',
    quote: {
      en: '360Gaming Solutions transformed our operations completely. Their expertise in risk management alone saved us millions.',
      gr: 'Η 360Gaming Solutions μεταμόρφωσε πλήρως τις λειτουργίες μας. Η εξειδίκευσή τους στη διαχείριση ρίσκου μας εξοικονόμησε εκατομμύρια.'
    }
  },
  {
    id: 2,
    name: { en: 'Elena Papadopoulou', gr: 'Έλενα Παπαδοπούλου' },
    role: { en: 'COO, Betkeko', gr: 'COO, Betkeko' },
    image: 'https://images.unsplash.com/photo-1758599543125-0a927f1d7a3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHdvbWFuJTIwcG9ydHJhaXQlMjBkYXJrfGVufDB8fHx8MTc3NTQ3NTEzM3ww&ixlib=rb-4.1.0&q=85',
    quote: {
      en: 'The BetGuard platform increased our affiliate conversions by 340%. A game-changer for our business.',
      gr: 'Η πλατφόρμα BetGuard αύξησε τα affiliate conversions μας κατά 340%. Μεγάλη αλλαγή για την επιχείρησή μας.'
    }
  },
  {
    id: 3,
    name: { en: 'Dimitris Konstantinidis', gr: 'Δημήτρης Κωνσταντινίδης' },
    role: { en: 'Director, CasinoNova', gr: 'Διευθυντής, CasinoNova' },
    image: 'https://images.unsplash.com/photo-1750741268857-7e44510f867d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMG1hbiUyMHBvcnRyYWl0JTIwZGFya3xlbnwwfHx8fDE3NzU0NzUxMzN8MA&ixlib=rb-4.1.0&q=85',
    quote: {
      en: 'Professional, knowledgeable, and results-driven. The team at 360Gaming Solutions exceeded all our expectations.',
      gr: 'Επαγγελματίες, με γνώση και προσανατολισμένοι σε αποτελέσματα. Η ομάδα της 360Gaming Solutions ξεπέρασε όλες μας τις προσδοκίες.'
    }
  }
];
